import { useEffect, useMemo, useState } from 'react';
import { format } from 'date-fns/esm';
import { parseISO } from 'date-fns';
import {
  SalesOrderInfo,
  selectSalesOrders,
  fetchSalesOrders,
  selectSalesOrdersStatus,
  selectServicesTranslations,
  fetchServicesTranslations,
} from '../../store/slices/salesOrders';
import {
  resetCreateStatus,
  createWorkOrderServiceDiagnostic,
  selectWorkOrderServiceDiagnosticCreateStatus,
} from '../../store/slices/workOrderServiceDiagnostic';
import {
  selectDiagnosticResults,
  selectDiagnosticResultsStatus,
  fetchDiagnosticResults,
  DiagnosticResult,
} from '../../store/slices/diagnosticResults';
import {
  selectSamplesTakenEditingStatus,
  resetEditingStatus as sampleTakenResetEditingStatus,
} from '../../store/slices/samplesTaken';
import { useAppDispatch, useAppSelector } from '../../store/store';
import classes from './Diagnostics.module.css';
import ScanSampleModal from './Modals/ScanSampleModal';
import Spinner from '../../components/UI/Spinner/Spinner';

import { fetchServicesWithBiomarkerInfo } from '../../store/slices/services';
import { ReportsPageHeader } from '../../components/Headers/ReportsPageHeader';
import { ReportsTableHeader } from '../../components/Headers/ReportsTableHeader';
import { ReportTable } from '../../components/UI/Layouts/ReportTable';
import { PatientInfo, Sample, Result } from './Tabs';
import { DiagnosticDocuments } from './Tabs/DiagnosticDocuments';
import { selectBusinessPartnerId, selectUserLocation } from '../../store/slices/auth';
import { IDiagnosticReportsExport } from '../../components/UI/ExportToExcel/ExportToExcel';
import { statusNameById } from '../../utils/statusUtils';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import DiagnosticsChat from './DiagnosticsChat';
import { IDigitalHealthProfile } from '../../components/UI/SelectedSalesOrder/DigitalHealthProfileTab';
import { findProductWithTaIdAndTransactionId } from '../../helpers';
import CustomPagination from '../../components/UI/CustomPagination/CustomPagination';
import { useTranslation } from '../../hooks/useTranslations';

type Props = {
  hideHeader?: boolean;
};

const Diagnostics: React.FC<Props> = ({ hideHeader }) => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const navigate = useNavigate();
  const [sampleIdSearch] = useState<string>('');
  const [diagnosticSearch] = useState<string>('');
  const [firstNameSearch, setFirstNameSearch] = useState<string>('');
  const [lastNameSearch] = useState<string>('');
  const [statusSearch] = useState<string>('');
  const [bookingDateSearch] = useState<string>('');
  const [isEditingDiagnosticOrder, setIsEditingDiagnosticOrder] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<number>(2);
  const [isLinkingSample, setIsLinkingSample] = useState<boolean>(false);
  const [selectedSalesOrder, setSelectedSalesOrder] = useState<SalesOrderInfo>();
  const [sampleBarcode, setSampleBarcode] = useState<string>('');
  const [scanDisabled, setScanDisabled] = useState<boolean>(false);
  const [enhancedSalesOders, setEnhancedSalesOrders] = useState<SalesOrderInfo[]>([]);
  const [displaySalesOrders, setDisplaySalesOrders] = useState<SalesOrderInfo[]>([]);
  const [startDateValue, setStartDateValue] = useState<Date | undefined>();
  const [endDateValue, setEndDateValue] = useState<Date | undefined>();
  const [hasSearchedWithDate, setHasSearchedWithDate] = useState<boolean>(false);
  const salesOrders: SalesOrderInfo[] = useAppSelector<SalesOrderInfo[]>(selectSalesOrders);
  const workOrderCreateStatus = useAppSelector<string>(
    selectWorkOrderServiceDiagnosticCreateStatus
  );
  const sampleTakenUpdateStatus = useAppSelector<string>(selectSamplesTakenEditingStatus);
  const fetchDiagnosticResultsStatus = useAppSelector<string>(selectDiagnosticResultsStatus);
  const fetchSalesOrdersStatus = useAppSelector<string>(selectSalesOrdersStatus);
  const diagnosticResults: DiagnosticResult[] =
    useAppSelector<DiagnosticResult[]>(selectDiagnosticResults);
  const businessPartnerId = useAppSelector<string>(selectBusinessPartnerId);
  const [isFetchingSalesOrders, setIsFetchingSalesOrders] = useState<boolean>(true);
  const [productOrder, setProductOrder] = useState<IDigitalHealthProfile>();
  const userLocation: string = useAppSelector<string>(selectUserLocation);

  const lang = localStorage.getItem('lang') || 'en';
  

  const servicesTranslations = useAppSelector(selectServicesTranslations);

  const translationsMap = useMemo(() => {
    const map: Record<number, Record<string, string>> = {};
    servicesTranslations?.forEach((service: any) => {
      const id = Number(service.service_id);
      map[id] = {};
  service.translations.forEach((tr: any) => {
  const langKey = tr.language.trim().toLowerCase();
  map[id][langKey] = tr.service_name;
});

    });
    return map;
  }, [servicesTranslations]);
  
  


  useEffect(() => { dispatch(fetchServicesTranslations()); }, [dispatch]);
  const defaultTabs = [
    {
      displayName: translations('patient'),
      value: 0,
    },
    {
      displayName: translations('sample'),
      value: 1,
    },
    {
      displayName: translations('results'),
      value: 2,
    },
    {
      displayName: translations('documents'),
      value: 3,
    },
  ];
  const [tabs, setTabs] = useState(defaultTabs);
  const [filterByStatus, setFilterByStatus] = useState<number>();
  const [filterByService, setFilterByService] = useState<number>();
  const [appointmentSortOrder, setAppointmentSortOrder] = useState<'asc' | 'desc' | null>(null);
  const [bookingSortOrder, setBookingSortOrder] = useState<'asc' | 'desc' | null>(null);

  useEffect(() => {
    dispatch(fetchSalesOrders());
    dispatch(fetchDiagnosticResults());
    dispatch(fetchServicesWithBiomarkerInfo());
  }, [dispatch]);

  useEffect(() => {
    if (fetchSalesOrdersStatus === 'pending') setIsFetchingSalesOrders(true);
    else setIsFetchingSalesOrders(false);
  }, [fetchSalesOrdersStatus]);

  useEffect(() => {
    if (workOrderCreateStatus === 'fulfilled') {
      dispatch(resetCreateStatus());
      dispatch(fetchSalesOrders());
      dispatch(fetchDiagnosticResults());
      setIsLinkingSample(false);
      setScanDisabled(false);
    } else if (workOrderCreateStatus === 'rejected') {
      setScanDisabled(false);
    }
  }, [workOrderCreateStatus, dispatch]);


useEffect(() => {
  if (fetchDiagnosticResultsStatus === 'fulfilled' && fetchSalesOrdersStatus === 'fulfilled') {
    let tempoSalesOrders: SalesOrderInfo[] = [];
    for (const saleOrder of salesOrders.filter(
      (salesOrder) =>
        salesOrder.service_service_group?.service_group_id === 1 ||
        salesOrder.service_service_group?.service_group_id === 4
    )) {
      if (
        saleOrder.work_order_service_diagnostic &&
        diagnosticResults.filter(
          (d) => d.work_order_id == saleOrder.work_order_service_diagnostic?.work_order_id
        ).length > 0
      ) {
        tempoSalesOrders.push({
          ...saleOrder,
          diagnostic_results: saleOrder.diagnostic_results
            ? [
              ...saleOrder.diagnostic_results,
              ...diagnosticResults.filter(
                (d) => d.work_order_id == saleOrder.work_order_service_diagnostic?.work_order_id
              ),
            ]
            : [
              ...diagnosticResults.filter(
                (d) => d.work_order_id == saleOrder.work_order_service_diagnostic?.work_order_id
              ),
            ],
        });
      } else {
        tempoSalesOrders.push({ ...saleOrder });
      }
    }
    tempoSalesOrders = tempoSalesOrders.map((order: any) => ({
      ...order,
      validatedByFullName: order.validationbyperson
        ? `${order.validationbyperson.person_firstname || ''} ${order.validationbyperson.person_lastname || ''
          }`.trim()
        : '',
    }));

      tempoSalesOrders = tempoSalesOrders.map((order: any) => {

        const serviceId = Number(order?.service?.service_id);
const langKey = lang.trim().toLowerCase();

const translatedName =
  translationsMap?.[serviceId]?.[langKey]?.trim() && translationsMap?.[serviceId]?.[langKey] !== ''
    ? translationsMap[serviceId][langKey]
    : ''; 
        const validatedByFullName =
          (order as any)?.validationbyperson
            ? `${(order as any)?.validationbyperson?.person_firstname || ''} ${
                (order as any)?.validationbyperson?.person_lastname || ''
              }`.trim()
            : '';
  
        return {
          ...order,
          validatedByFullName,
          service: {
            ...order.service,
            service_name: translatedName,
          },
        };
      });

    setEnhancedSalesOrders(tempoSalesOrders);
  }
}, [
      fetchDiagnosticResultsStatus,
      fetchSalesOrdersStatus,
      salesOrders,
      diagnosticResults,
      translationsMap,
      lang,
    ]);

  useEffect(() => {
    setDisplaySalesOrders([...enhancedSalesOders]);
  }, [enhancedSalesOders]);

  useEffect(() => {
    if (sampleTakenUpdateStatus === 'fulfilled') {
      dispatch(sampleTakenResetEditingStatus());
      dispatch(fetchSalesOrders());
      dispatch(fetchDiagnosticResults());
    }
  }, [sampleTakenUpdateStatus, dispatch]);

  useEffect(() => {
    let tempoSalesOrders = [...enhancedSalesOders];
    if (sampleIdSearch.trim().length > 0)
      tempoSalesOrders = tempoSalesOrders.filter((salesOrder) => {
        if (
          salesOrder &&
          salesOrder.diagnostic_results &&
          salesOrder.diagnostic_results[0].sample_barcode
        ) {
          return salesOrder.diagnostic_results[0]?.sample_barcode
            .toLowerCase()
            .includes(sampleIdSearch.toLocaleLowerCase());
        }
        return false;
      });
    if (diagnosticSearch.trim().length > 0)
      tempoSalesOrders = tempoSalesOrders.filter((salesOrder) =>
        salesOrder.product.product_name.toLowerCase().includes(diagnosticSearch.toLocaleLowerCase())
      );
    if (firstNameSearch.trim().length > 0)
      tempoSalesOrders = tempoSalesOrders.filter((salesOrder) =>
        `${salesOrder.customer_person.person_firstname}${salesOrder.customer_person.person_lastname}`
          .toLowerCase()
          .includes(firstNameSearch.toLocaleLowerCase())
      );
    if (lastNameSearch.trim().length > 0)
      tempoSalesOrders = tempoSalesOrders.filter((salesOrder) =>
        salesOrder.customer_person.person_lastname
          .toLowerCase()
          .includes(lastNameSearch.toLocaleLowerCase())
      );
    if (statusSearch.trim().length > 0)
      tempoSalesOrders = tempoSalesOrders.filter((salesOrder) => {
        const tempoStatus =
          salesOrder.work_order?.work_order_status_id === 2
            ? translations('closed')
            : salesOrder.work_order?.work_order_status_id === 1
              ? translations('pending')
              : translations('open');
        if (tempoStatus.toLowerCase().includes(statusSearch.toLocaleLowerCase())) return true;
        return false;
      });
    if (bookingDateSearch.trim().length > 0) {
      tempoSalesOrders = tempoSalesOrders.filter((salesOrder) =>
        format(
          parseISO(salesOrder?.sales_order?.datetime_create?.toString() ?? '01-01-1111'),
          'dd.MM.yyyy'
        )
          .toLowerCase()
          .includes(bookingDateSearch.toLocaleLowerCase())
      );
    }

    if (filterByService) {
      tempoSalesOrders = tempoSalesOrders.filter(
        (salesOrder) => salesOrder.service.service_id === filterByService
      );
    }
    if (filterByStatus) {
      tempoSalesOrders = tempoSalesOrders.filter((salesOrder) => {
        const status_id = filterByStatus === -1 ? undefined : filterByStatus;
        return salesOrder.work_order?.work_order_status_id === status_id;
      });
    }
    setDisplaySalesOrders([...tempoSalesOrders]);
  }, [
    sampleIdSearch,
    diagnosticSearch,
    firstNameSearch,
    lastNameSearch,
    statusSearch,
    bookingDateSearch,
    enhancedSalesOders,
    hasSearchedWithDate,
    startDateValue,
    endDateValue,
    filterByStatus,
    filterByService,
  ]);

  useEffect(() => {
    setHasSearchedWithDate(false);
  }, [startDateValue, endDateValue]);

  useEffect(() => {
    setTabs(defaultTabs);
    const checkProduct = async () => {
      const productFound = await findProductWithTaIdAndTransactionId(selectedSalesOrder);
      if (productFound && productFound.conversation_id) {
        setProductOrder(productFound);
        setTabs([
          ...tabs,
          {
            displayName: translations('chat'),
            value: 4,
          },
        ]);
      }
    };
    checkProduct();
  }, [selectedSalesOrder?.customer_person.person_account_number]);

  const maxDate = useMemo(() => {
    const dates = enhancedSalesOders
      .filter((salesOrder) => salesOrder.sales_order_appointment?.start)
      .map((salesOrder) => new Date(salesOrder.sales_order_appointment?.start ?? '').getTime());
    return new Date(Math.max.apply(null, dates.length > 0 ? dates : [new Date().getTime()]));
  }, [enhancedSalesOders]);

  const serviceTypes = useMemo(() => {
    const uniqueServices: { [key: string]: { service_id: number; service_name: string } } = {};

    enhancedSalesOders.forEach((data) => {
      const { service } = data;
      if (service) {
        const { service_id, service_name } = service;
        if (service_id && service_name) {
          uniqueServices[service_id] = { service_id, service_name };
        }
      }
    });
    return Object.values(uniqueServices);
  }, [enhancedSalesOders]);

  const handleBookTestClick = () => {
    const person_id = selectedSalesOrder?.customer_person.person_id;
    navigate({
      pathname: '/web/sales/orders',
      search: `?person_id=${person_id}`,
    });
  };

  const sortByAppointmentDate = (items: SalesOrderInfo[], order: 'asc' | 'desc') => {
    return [...items].sort((a, b) => {
      const dateA = a.sales_order_appointment?.start
        ? new Date(a.sales_order_appointment.start).getTime()
        : 0;
      const dateB = b.sales_order_appointment?.start
        ? new Date(b.sales_order_appointment.start).getTime()
        : 0;

      if (order === 'asc') {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });
  };

  const sortByBookingDate = (items: SalesOrderInfo[], order: 'asc' | 'desc') => {
    return [...items].sort((a, b) => {
      const dateA = new Date(a.sales_order.datetime_create).getTime();
      const dateB = new Date(b.sales_order.datetime_create).getTime();

      if (order === 'asc') {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });
  };

  const handleDateSort = (columnType: 'booking' | 'appointment') => {
    if (columnType === 'appointment') {
      setBookingSortOrder(null);
      if (appointmentSortOrder === null || appointmentSortOrder === 'desc') {
        setAppointmentSortOrder('asc');
        return 'asc';
      } else {
        setAppointmentSortOrder('desc');
        return 'desc';
      }
    } else {
      setAppointmentSortOrder(null);
      if (bookingSortOrder === null || bookingSortOrder === 'desc') {
        setBookingSortOrder('asc');
        return 'asc';
      } else {
        setBookingSortOrder('desc');
        return 'desc';
      }
    }
  };

  const sortedDisplaySalesOrders = useMemo(() => {
    if (appointmentSortOrder) {
      return sortByAppointmentDate(displaySalesOrders, appointmentSortOrder);
    }
    if (bookingSortOrder) {
      return sortByBookingDate(displaySalesOrders, bookingSortOrder);
    }

    return sortByBookingDate(displaySalesOrders, 'desc');
  }, [displaySalesOrders, appointmentSortOrder, bookingSortOrder]);


  return (
    
    <div className={classes.container}>
      {!hideHeader && (
        <ReportsPageHeader
          label={translations('diagnostic.reports.diagnostics_order').toString()}
          onBackButtonClick={() => {
            setIsEditingDiagnosticOrder(false);
            setSelectedSalesOrder(undefined);
          }}
          selectedSalesOrder={selectedSalesOrder}
        />
      )}
      <ReportsTableHeader
        tabs={tabs}
        isDropdown
        selectedSalesOrder={selectedSalesOrder}
        firstNameSearch={firstNameSearch}
        setFirstNameSearch={setFirstNameSearch}
        setDateBegin={setStartDateValue}
        dateBegin={startDateValue}
        setDateEnd={setEndDateValue}
        maxAppointmentDate={maxDate}
        dateEnd={endDateValue}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        onClose={() => {
          setIsEditingDiagnosticOrder(false);
          setSelectedSalesOrder(undefined);
          // setSelectedTab(0);
        }}
        onBookAnotherTest={handleBookTestClick}
        filterByService={filterByService}
        setFilterByService={setFilterByService}
        serviceTypes={serviceTypes}
        filterByStatus={filterByStatus}
        statusTypes={[
          { id: -1, label: translations('open') },
          { id: 1, label: translations('pending') },
          { id: 2, label: translations('closed') },
          { id: 3, label: translations('void') },
        ]}
        setFilterByStatus={setFilterByStatus}
        showExportButton={!isEditingDiagnosticOrder}
        dataToExport={displaySalesOrders.map((data: SalesOrderInfo) => {
          return {
            sales_order_id: data?.sales_order?.sales_order_id,
            last_name: data?.customer_person?.person_lastname,
            first_name: data?.customer_person?.person_firstname,
            status: translations(statusNameById(translations, data?.work_order?.work_order_status_id)),
            service_name: data.service?.service_name,
            booking_date: moment(data?.sales_order?.datetime_create).format('DD.MM.YYYY HH:mm'),
            result: data.diagnostic_results?.find(
              (diagnosticRes) => diagnosticRes.biomarker_text_result !== null
            )
              ? data.diagnostic_results?.find(
                (diagnosticRes) => diagnosticRes.biomarker_text_result !== null
              )?.biomarker_text_result
              : '',
            sample_id:
              data.diagnostic_results && data.diagnostic_results[0]
                ? data.diagnostic_results[0].sample_barcode
                : '',
            validated_by: data.validationByPerson?.person_firstname,
            appointment_date: data?.sales_order_appointment?.start
              ? moment(data?.sales_order_appointment?.start).format('DD.MM.YYYY HH:mm')
              : '',
            person_mobile_phone: data?.customer_person?.person_mobile_phone,
            person_email: data?.customer_person?.person_email,
            reference: data?.sales_order?.ta_id + '/' + data?.sales_order?.transaction_id,
            station_name: userLocation,
            day_of_sample_taking: moment(data?.work_order_service_diagnostic?.check_in_time).format(
              'DD.MM.YYYY HH:mm'
            ),
          } as IDiagnosticReportsExport;
        })}
      />

      {isEditingDiagnosticOrder && selectedSalesOrder && (
        <div className={classes.editDiagnosticsContainer}>
          {selectedTab === 0 && <PatientInfo selectedSalesOrder={selectedSalesOrder} />}
          {selectedTab === 1 &&
            (selectedSalesOrder?.work_order_service_diagnostic ? (
              <Sample selectedSalesOrder={selectedSalesOrder} />
            ) : (
              <div className={classes.noDataContainer}>
                <div className={classes.noDataMessage}>{translations('diagnostic.no.data')}</div>
              </div>
            ))}
          {selectedTab === 2 &&
            (selectedSalesOrder?.work_order_service_diagnostic ? (
              <Result
                selectedSalesOrder={selectedSalesOrder}
                setSelectedSalesOrder={setSelectedSalesOrder}
              />
            ) : (
              <div className={classes.noDataContainer}>
                <div className={classes.noDataMessage}>{translations('diagnostic.no.data')}</div>
              </div>
            ))}
          {selectedTab === 3 &&
            (selectedSalesOrder.work_order_service_diagnostic ? (
              <DiagnosticDocuments selectedSalesOrder={selectedSalesOrder} />
            ) : (
              <div className={classes.noDataContainer}>
                <div className={classes.noDataMessage}>{translations('diagnostic.no.data')}</div>
              </div>
            ))}
          {selectedTab === 4 && <DiagnosticsChat product={productOrder} />}
        </div>
      )}
      {isFetchingSalesOrders && <Spinner />}
      {!isEditingDiagnosticOrder && !isFetchingSalesOrders && (
        <>
          <CustomPagination
            itemsPerPage={10}
            items={sortedDisplaySalesOrders}
            style={{ margin: '0px' }}
          >
            
            {(paginatedItems: any[]) => (
              
              <ReportTable
                columns={[
                  {
                    name: 'ID',
                    path: 'sales_order.sales_order_id',
                    type: 'ID',
                  },
                  {
                    name: translations('last_name'),
                    path: 'customer_person.person_lastname',
                    type: 'TEXT',
                  },
                  {
                    name: translations('first_name'),
                    path: 'customer_person.person_firstname',
                    type: 'TEXT',
                  },
                  {
                    name: translations('status'),
                    path: 'work_order.work_order_status_id',
                    type: 'STATUS',
                  },
                  {
                    name: translations('service'),
                    path: 'service.service_name',
                    type: 'TEXT',
                  },
                  {
                    name: translations('booking_date'),
                    path: 'sales_order.datetime_create',
                    type: 'DATETIME',
                    sortOrder: bookingSortOrder,
                    onSort: () => handleDateSort('booking'),
                  },
                  {
                    name: translations('result.date.time'),
                    path: 'work_order_service_diagnostic.result_delivery_time',
                    type: 'DATETIME',
                  },
                  {
                    name: translations('validated.by'),
                    path: 'validatedByFullName',
                    type: 'TEXT',
                  },
                  {
                    name: translations('appointment.date'),
                    path: 'sales_order_appointment.start',
                    type: 'DATETIME',
                    sortOrder: appointmentSortOrder,
                    onSort: () => handleDateSort('appointment'),
                  },
                ]}
                rows={paginatedItems}
                actions={[
                  {
                    displayName: translations('view'),
                    onClick: (row) => {
                      // if (
                      //   (row as SalesOrderInfo).work_order_service_diagnostic
                      //     ?.outside_laboratory === 1
                      // ) {
                      //   toast.error(translations('cannot.edit'), {
                      //     position: toast.POSITION.BOTTOM_RIGHT,
                      //   });
                      //   return;
                      // }
                      setSelectedSalesOrder(row as SalesOrderInfo);
                      setIsEditingDiagnosticOrder(true);
                      setSelectedTab(2);
                    },
                  },
                ]}
              />
            )}
          </CustomPagination>
          <ScanSampleModal
            title={translations('scan.sample.id')}
            isOpen={isLinkingSample}
            onClose={() => setIsLinkingSample(false)}
            onConfirm={() => {
              if (selectedSalesOrder) {
                dispatch(
                  createWorkOrderServiceDiagnostic({
                    salesOrderId: selectedSalesOrder?.sales_order.sales_order_id,
                    salesOrderItemId: selectedSalesOrder?.sales_order_item.sales_order_item_id,
                    serviceId: selectedSalesOrder?.service.service_id,
                    employeeId: selectedSalesOrder?.sales_order.business_person_id,
                    businessPartnerId: businessPartnerId,
                    sampleBarcode: sampleBarcode,
                    isOutsideLaboratory: false,
                    personEmail: selectedSalesOrder?.customer_person?.person_email ?? '',
                    personAccountNumber:
                      selectedSalesOrder?.customer_person?.person_account_number ?? '',
                    taId: selectedSalesOrder.sales_order.ta_id ?? 0,
                    transactionId: selectedSalesOrder.sales_order.transaction_id ?? 0,
                  })
                );
              }
            }}
            scan={true}
            apiStatus={workOrderCreateStatus}
            sampleBarcode={sampleBarcode}
            onChangeSampleBarcode={(e: any) => setSampleBarcode(e?.target?.value)}
            scanDisabled={scanDisabled}
            onSuccessScan={(decodedText: any) => {
              if (decodedText && selectedSalesOrder) {
                setScanDisabled(true);
                dispatch(
                  createWorkOrderServiceDiagnostic({
                    salesOrderId: selectedSalesOrder?.sales_order.sales_order_id,
                    salesOrderItemId: selectedSalesOrder?.sales_order_item.sales_order_item_id,
                    serviceId: selectedSalesOrder?.service.service_id,
                    employeeId: selectedSalesOrder?.sales_order.business_person_id,
                    businessPartnerId: businessPartnerId,
                    sampleBarcode: decodedText,
                    isOutsideLaboratory: false,
                    personEmail: selectedSalesOrder?.customer_person?.person_email ?? '',
                    personAccountNumber:
                      selectedSalesOrder?.customer_person?.person_account_number ?? '',
                    taId: selectedSalesOrder.sales_order.ta_id ?? 0,
                    transactionId: selectedSalesOrder.sales_order.transaction_id ?? 0,
                  })
                );
              }
            }}
          />
        </>
      )}
    </div>
  );
};

export default Diagnostics;
